module.exports = {
  returnName: {
    1: 'Grupo ou Complemento',
    2: 'Contratante',
    3: 'Usuário Espelho',
  },

  returnNameFormatted: {
    0: 'Selecione uma opção',
    1: 'Grupo ou Complemento',
    2: 'Contratante',
  },
  returnId: {
    'Grupo ou Complemento': 1,
    Contratante: 2,
  },
  returnNameForName: {
    'Grupo ou Complemento': 'Grupo ou Complemento',
    Contratante: 'Contratante',
  },
  returnIdForNameFormatted: {
    'Selecione uma opção': 0,
    'Grupo ou Complemento': 1,
    Contratante: 2,
  },

  returnPlaceHolderForName: {
    'Grupo ou Complemento': 'Digite o código do grupo ou complemento',
    Contratante: 'Digite o código ou nome de contratante',
    'Usuário Espelho': 'Digite o nome ou email do usuário espelho',
  },
};
